module.exports = __webpack_public_path__ + "static/img/icon-contactUs.6805d56a.png";